const FONT_COLORS = [
  { color: 'hsl(0, 0%, 0%)', label: 'Black' },
  { color: 'hsl(0, 0%, 30%)', label: 'Dim grey' },
  { color: 'hsl(0, 0%, 60%)', label: 'Grey' },
  { color: 'hsl(0, 0%, 90%)', label: 'Light grey' },
  { color: 'hsl(0, 0%, 100%)', label: 'White' },
  { color: 'hsl(0, 75%, 60%)', label: 'Red' },
  { color: 'hsl(30, 75%, 60%)', label: 'Orange' },
  { color: 'hsl(60, 75%, 60%)', label: 'Yellow' },
  { color: 'hsl(90, 75%, 60%)', label: 'Light green' },
  { color: 'hsl(120, 75%, 60%)', label: 'Green' },
  { color: 'hsl(150, 75%, 60%)', label: 'Aquamarine' },
  { color: 'hsl(180, 75%, 60%)', label: 'Turquoise' },
  { color: 'hsl(210, 75%, 60%)', label: 'Light blue' },
  { color: 'hsl(240, 75%, 60%)', label: 'Blue' },
  { color: 'hsl(270, 75%, 60%)', label: 'Purple' },
];

const applyFontColor = (editor: any, color?: string) => {
  editor.model.change((writer: any) => {
    const { selection } = editor.model.document;
    if (selection.isCollapsed) {
      if (color) {
        writer.setSelectionAttribute('fontColor', color);
      } else {
        writer.removeSelectionAttribute('fontColor');
      }
      return;
    }
    const ranges = editor.model.schema.getValidRanges(
      selection.getRanges(),
      'fontColor'
    );
    Array.from(ranges).forEach((range: any) => {
      if (color) {
        writer.setAttribute('fontColor', color, range);
      } else {
        writer.removeAttribute('fontColor', range);
      }
    });
  });
  editor.editing.view.focus();
};

const createToolbarView = (editor: any) => {
  const wrapper = document.createElement('div');
  wrapper.className = 'ck ck-dropdown ck-font-color';

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'ck ck-button ck-off ck-font-color-button';
  button.title = 'Font Color';
  button.setAttribute('aria-label', 'Font Color');
  button.innerHTML =
    '<span class="ck-font-color-letter">A</span><span class="ck-font-color-bar"></span>';

  const panel = document.createElement('div');
  panel.className = 'ck-font-color-panel';
  panel.setAttribute('hidden', 'true');

  const grid = document.createElement('div');
  grid.className = 'ck-font-color-grid';

  FONT_COLORS.forEach(({ color, label }) => {
    const swatch = document.createElement('button');
    swatch.type = 'button';
    swatch.className = 'ck-font-color-swatch';
    swatch.title = label;
    swatch.style.backgroundColor = color;
    if (label === 'White') {
      swatch.style.border = '1px solid #ccc';
    }
    swatch.addEventListener('mousedown', (event) => {
      event.preventDefault();
      applyFontColor(editor, color);
      const bar = button.querySelector('.ck-font-color-bar') as HTMLElement;
      if (bar) {
        bar.style.backgroundColor = color;
      }
      panel.setAttribute('hidden', 'true');
    });
    grid.appendChild(swatch);
  });

  const removeBtn = document.createElement('button');
  removeBtn.type = 'button';
  removeBtn.className = 'ck-font-color-remove';
  removeBtn.textContent = 'Remove color';
  removeBtn.addEventListener('mousedown', (event) => {
    event.preventDefault();
    applyFontColor(editor);
    const bar = button.querySelector('.ck-font-color-bar') as HTMLElement;
    if (bar) {
      bar.style.backgroundColor = '#000';
    }
    panel.setAttribute('hidden', 'true');
  });

  panel.appendChild(grid);
  panel.appendChild(removeBtn);
  wrapper.appendChild(button);
  wrapper.appendChild(panel);

  button.addEventListener('mousedown', (event) => {
    event.preventDefault();
    const isHidden = panel.hasAttribute('hidden');
    if (isHidden) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', 'true');
    }
  });

  const closePanel = (event: MouseEvent) => {
    if (!wrapper.contains(event.target as Node)) {
      panel.setAttribute('hidden', 'true');
    }
  };
  document.addEventListener('mousedown', closePanel);

  return {
    element: wrapper,
    isRendered: true,
    render() {},
    destroy() {
      document.removeEventListener('mousedown', closePanel);
      wrapper.remove();
    },
  };
};

class FontColorPlugin {
  static get pluginName() {
    return 'FontColor';
  }

  editor: any;

  constructor(editor: any) {
    this.editor = editor;
  }

  init() {
    const { editor } = this;

    editor.model.schema.extend('$text', { allowAttributes: 'fontColor' });

    editor.conversion.for('downcast').attributeToElement({
      model: 'fontColor',
      view: (color: string, { writer }: any) =>
        writer.createAttributeElement(
          'span',
          { style: `color:${color}` },
          { priority: 7 }
        ),
    });

    editor.conversion.for('upcast').elementToAttribute({
      view: {
        name: 'span',
        styles: {
          color: /[\s\S]+/,
        },
      },
      model: {
        key: 'fontColor',
        value: (viewElement: any) => viewElement.getStyle('color'),
      },
    });

    editor.ui.componentFactory.add('fontColor', () => createToolbarView(editor));
  }
}

export default FontColorPlugin;
